import $ from 'jquery';

const newsletterSignup = () => {
    const $subscriptionForm = $('.s-newsletter-signup-forms');

    if ($subscriptionForm.length === 0) return;

    $subscriptionForm.each(function () {
        const $inputName = $('input[type=text]', this);
        const $inputEmail = $('input[type=email]', this);
        const $spinner = $('.c-loader', this);
        const $submitBtn = $('button', this);
        const $responseMsg = $('.response-msg', this);

        const showSpinner = () => {
            $spinner.addClass('show');
        };

        const hideSpinner = () => {
            $spinner.removeClass('show');
        };

        const validateEmail = element => {
            const emailRegex = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
            const emailValue = element.val();

            return (emailValue.length > 1 && emailRegex.test(emailValue));
        };

        const submitForm = reqObj => {
            const domain = window.location.hostname === 'localhost' ? 'http://www.gsdemo.com.dev/' : '';

            $.ajax({
                type: 'POST',
                url: `${domain}/api/mailchimp/subscribe`,
                data: reqObj,
                success(data) {
                    if (data.status === 'success') {
                        $responseMsg
                            .text(data.message)
                            .removeClass('invalid')
                            .addClass('success show');
                    } else {
                        $responseMsg
                            .text(data.message)
                            .addClass('invalid show');
                    }
                },
                error() {
                    $responseMsg
                        .text('Error encountered, please try again later.')
                        .addClass('invalid show');
                },
                complete() {
                    hideSpinner();
                }
            });
        };

        const submitSubscription = () => {
            const isValid = validateEmail($inputEmail);

            if ($inputName.val().length > 1) {
                $inputName.parent().removeClass('Error');

                if ($inputEmail.val().length > 1 && isValid) {
                    $inputEmail.parent().removeClass('Error');

                    showSpinner();

                    const dataObj = { email: $inputEmail.val() };

                    submitForm(dataObj);
                } else {
                    $inputEmail.parent().addClass('Error');
                }
            } else {
                $inputName.parent().addClass('Error');

                if ($inputEmail.val().length > 1) {
                    $inputEmail.parent().removeClass('Error');
                } else {
                    $inputEmail.parent().addClass('Error');
                }
            }
        };

        $submitBtn.on('click', () => {
            submitSubscription();
        });

        $inputEmail.on('keypress', e => {
            if (e.keyCode === 13) {
                submitSubscription();
            }
        });
    });
};

// doc ready
$(() => {
    newsletterSignup();
});



// WEBPACK FOOTER //
// ./src/sections/newsletter-signup/s-newsletter-signup.js